function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Form, Input, Button, Alert, notification, message } from 'antd';
import { CheckCircleFill } from 'react-bootstrap-icons';
import { Spinner } from "react-bootstrap";
import { useNavigate } from 'react-router-dom';
import Common from "../includes/Common";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var MobileConfirmForm = function MobileConfirmForm(_ref) {
  var mobile = _ref.mobile,
    fname = _ref.fname;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormError = _useState2[0],
    setIsFormError = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    formLoading = _useState4[0],
    setFormLoading = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    errorMessage = _useState6[0],
    setErrorMessage = _useState6[1];
  var navigate = useNavigate();
  var onFinish = function onFinish(values) {
    setFormLoading(true);
    setIsFormError(false);
    var formData = new FormData();
    formData.append('confcode', values.confcode);
    axios.post(Common.baseApiUrl + 'confirmusermobile/' + JSON.parse(localStorage.getItem('userData')).id, formData).then(function (response) {
      setFormLoading(false);
      if (response.data.status == 200) {
        navigate('/home/welcome');
        location.reload();
      } else {
        setErrorMessage(response.data.message);
        setIsFormError(true);
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 3
      });
    });
  };
  var onFinishFailed = function onFinishFailed(errorInfo) {};
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("h3", {
      children: [" Bonjour, ", fname]
    }), /*#__PURE__*/_jsxs("div", {
      style: {
        fontSize: '15px',
        padding: '10px 0px'
      },
      children: ["Votre compte est cr\xE9\xE9, vous recevrez un SMS avec votre ", /*#__PURE__*/_jsxs("b", {
        children: ["code de confirmation sur le ", mobile]
      })]
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Form, {
      name: "mconfirm",
      layout: "vertical",
      initialValues: {
        remember: true
      },
      onFinish: onFinish,
      onFinishFailed: onFinishFailed,
      autoComplete: "off",
      children: [/*#__PURE__*/_jsx(Form.Item, {
        label: "Entrez le code de confirmation",
        name: "confcode",
        rules: [{
          required: true,
          message: 'Entrez le code de confirmation'
        }],
        children: /*#__PURE__*/_jsx(Input, {})
      }), isFormError ? /*#__PURE__*/_jsx(Alert, {
        style: {
          marging: '5px 0px'
        },
        message: errorMessage,
        type: "error",
        showIcon: true
      }) : /*#__PURE__*/_jsx("span", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Form.Item, {
        children: [/*#__PURE__*/_jsxs(Button, {
          type: "primary",
          size: "middle",
          htmlType: "submit",
          children: ["Confirmer ", /*#__PURE__*/_jsx(CheckCircleFill, {})]
        }), formLoading ? /*#__PURE__*/_jsx(Spinner, {
          animation: "grow",
          variant: "warning"
        }) : /*#__PURE__*/_jsx("span", {})]
      })]
    })]
  });
};
export default MobileConfirmForm;